import { SET_LABS_FILTERS, RESET_LABS_FILTERS } from '../actions/filterLaboratory'

export const DEFAULT = {
	items: [],
	currentPage: 1,
	itemsPerPage: 10,
	totalPages: 1,
	clinic: null,
	nOrder: null,
	date: null,
	patientERID: '',
	order: null
}

export const filterLaboratoryReducer = (state = DEFAULT, action) => {
	switch (action.type) {
		case SET_LABS_FILTERS:
			return { ...action.payload }
		case RESET_LABS_FILTERS:
			return DEFAULT
		default:
			return state
	}
}

export const selectLabsFilters = filterLaboratory => {
	return filterLaboratory ?? DEFAULT
}

export const selectLabsFiltersCount = filterLaboratory => {
	const f = selectLabsFilters(filterLaboratory)
	let count = 0
	if (f.clinic) count += 1
	if (f.date) count += 1
	if (f.order) count += 1
	return count
}
